// The desk header's totals for a maintenance option (#515): the repaint (year 1), then the contract.
import type { MaintenancePricing } from '../lib/maintenance-pricing';
import { formatMoney, formatPercent, formatSell } from './surface-format';

export const contractHeader = (pricing: MaintenancePricing, repaintSell: number, priceShown: boolean): [string, string][] => [
  ['Repaint (year 1)', formatSell(repaintSell, priceShown)],
  // The Yearly Summaries' totals: the contract, with the finance interest of a financed payment type.
  [`Contract Sell (${pricing.years} years)`, formatSell(pricing.yearly.sell, priceShown)],
  ['Contract Cost', formatMoney(pricing.yearly.cost)],
  ['GP%', formatPercent(pricing.yearly.gp)],
];
